export default __webpack_public_path__ + "static/media/submissions.7fb1e202.svg";